import type { ReactNode } from 'react'
import type { IntlShape } from 'react-intl'
import { defineMessages } from 'react-intl'

import type { Moment } from './moment'
import moment from './moment'

export type ReactIntlFormatter = ReactNode | ((msgs: ReactNode[]) => ReactNode)

export const defineFormatters = <K extends string>(formatters: Record<K, ReactIntlFormatter>) => formatters

const messages = defineMessages({
  date_today: { id: "utils.reactIntl.messages.date_today.9626", defaultMessage: 'Сегодня' },
  date_yesterday: { id: "utils.reactIntl.messages.date_yesterday.61d4", defaultMessage: 'Вчера' },
  date_tomorrow: { id: "utils.reactIntl.messages.date_tomorrow.d102", defaultMessage: 'Завтра' },
  date: { id: "utils.reactIntl.messages.date.5e54", defaultMessage: `D MMMM{isSameYear, select,
    false {[, ]YYYY}
    other {}
  }` },
  minute: { id: "utils.reactIntl.messages.minute.5e54", defaultMessage: `{value, plural,
    one {минута}
    few {минуты}
    other {минут}}` },
  hour: { id: "utils.reactIntl.messages.hour.5e54", defaultMessage: `{value, plural,
    one {час}
    few {часа}
    other {часов}}` },
})

export const formatRelativeDate = (formatMessage: IntlShape['formatMessage'], date: Moment, now: Moment = moment()) => {
  if (date.isSame(now, 'day')) return formatMessage(messages.date_today)
  if (date.isSame(now.clone().add(1, 'day'), 'day')) return formatMessage(messages.date_tomorrow)
  if (date.isSame(now.clone().add(-1, 'day'), 'day')) return formatMessage(messages.date_yesterday)

  return date.format(
    formatMessage(messages.date, {
      isSameYear: date.isSame(now, 'year'),
    })
  )
}

export const formatDuration = (
  formatMessage: IntlShape['formatMessage'],
  /** duration in minutes */
  duration: number
) => {
  const hh = Math.floor(duration / 60)
  const mm = duration % 60
  const out: string[] = []
  if (hh) {
    out.push(`${hh}\u00a0${formatMessage(messages.hour, { value: hh })}`)
  }
  if (mm) {
    out.push(`${mm}\u00a0${formatMessage(messages.minute, { value: mm })}`)
  }
  return out.join(' ')
}
